// API origin for READ-ONLY public content (blog posts) that must be present in
// the prerendered HTML.
//
// Production builds set REACT_APP_BACKEND_URL="" so the browser calls the
// same-origin /api behind Nginx. But react-snap snapshots pages from its own
// static server on localhost:45678, which has no /api — so without this, every
// blog post was prerendered with an empty <h1> and body. During the prerender
// pass only (Puppeteer UA "ReactSnap"), read from the live site instead.
// package.json's reactSnap.puppeteerArgs includes --disable-web-security so
// that cross-origin fetch is allowed inside the prerender browser only.
//
// Override the origin with REACT_APP_PRERENDER_API_URL (e.g. a local backend).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const isPrerender =
    typeof navigator !== "undefined" && navigator.userAgent.includes("ReactSnap");

export const CONTENT_API_ORIGIN =
    isPrerender && !BACKEND_URL
        ? process.env.REACT_APP_PRERENDER_API_URL || "https://reformityinc.com"
        : BACKEND_URL;
